import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Form, Offcanvas } from "react-bootstrap";
import Select from "react-select";
import { Controller, useForm } from "react-hook-form";
import Common_Back_Btn from "../../../../../common/common_components/common_back_btn/Common_Back_Btn";
import Gray_Btn from "../../../../../common/common_btn/gray_btn/Gray_Btn";
import Black_Submit_Btn from "../../../../../common/common_btn/black_submit_btn/Black_Submit_Btn";
import Success_Toster from "../../../../../common/common_modal/success_toster/Success_Toster";
import Refresh_btn from "../../../../../common/common_btn/refresh_btn/Refresh_btn";

const Edit_Role = ({ show, handleClose }) => {
  const onSubmit = async (data) => {
    handleClose();
    setSuccess(true);

     setTimeout(() => {
    setSuccess(false);
    handleClose();
  }, 3000);
  };

  const {
    register,
    handleSubmit,
    control,
    reset,
    formState: { errors },
    setError,
  } = useForm();
  const [showMap, setShowMap] = useState(false);
  const [hideForm, setHideForm] = useState(false);
  const [success, setSuccess] = useState(false);

  const [viewDoc, setViewDoc] = useState(false);

  const countries = [
    { label: "India", value: "1" },
    { label: "USA", value: "2" },
    { label: "UK", value: "3" },
  ];

  const [activeTab, setActiveTab] = useState("basic");

  const documentSectionRef = useRef(null);
  const basiSectionRef = useRef(null);

  const handleTabClick = (tab) => {
    setActiveTab(tab);

    if (tab === "basic" && basiSectionRef.current) {
      basiSectionRef.current.scrollIntoView({ behavior: "smooth" });
    }

    if (tab === "document" && documentSectionRef.current) {
      documentSectionRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <Offcanvas
      className="mobile_offcanvas common_offcanvas Edit_Role_offcanvas"
      show={show}
      placement="end"
      onHide={handleClose}
      scroll={false}
      backdrop={true}
    >
      <Offcanvas.Header>
        <Offcanvas.Title>
          <div className="back_div" onClick={handleClose}>
            <Common_Back_Btn />
          </div>
          Edit Role
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <div className="add_form">
          <Form onSubmit={handleSubmit(onSubmit)}>
            {/* form 2 */}
            <div className="white_container" ref={documentSectionRef}>
              <div className="common_form_div">
                <div className="row">
                  <div className="blue_form_box">
                    <div className="row">
                      <div className="col-sm-6">
                        <Form.Group
                          className="form_group"
                          controlId="formBasicName"
                        >
                          <Form.Label>Role Name</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="eg. LAB MANAGER"
                          />
                          {errors?.credit_price && (
                            <Form.Text className="text-danger">
                              {errors?.credit_price?.message}
                            </Form.Text>
                          )}
                        </Form.Group>
                      </div>
                      <div className="col-sm-6">
                        <Form.Group
                          className="form_group"
                          controlId="formBasicName"
                        >
                          <Form.Label>Role Description(Optional)</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Type Description"
                          />
                          {errors?.credit_price && (
                            <Form.Text className="text-danger">
                              {errors?.credit_price?.message}
                            </Form.Text>
                          )}
                        </Form.Group>
                      </div>
                    </div>
                  </div>

                  <div className="search_form_div">
                    <div className="col-sm-12">
                      <Form.Group
                        className="form_group"
                        controlId="formBasicName"
                      >
                        <Form.Label>Search Permission For Role:</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter Permissions"
                        />
                      </Form.Group>
                    </div>
                  </div>

                 
                    <div className="row">
                      <div className="col-sm-6">
                        <Form.Group
                          className="form_group"
                          controlId="formBasicName"
                        >
                          <Form.Label className="text_decoration">Permission Categories:</Form.Label>
                        </Form.Group>
                      </div>
                      <div className="col-sm-6">
                        <Form.Group
                          className="form_group"
                          controlId="formBasicName"
                        >
                          <Form.Label>
                            {" "}
                            <Form.Check
                              inline
                              type="checkbox"
                              label="Select All Permissions"
                              name="sampleType"
                              value="Select All Permissions"
                              id="Select All Permissions"
                            />
                          </Form.Label>
                        </Form.Group>
                      </div>
                    </div>
                     <div className="all_cats_div">

                    <div className="yellow_div">
                      <div className="row">
                        <div className="col-sm-12">
                          <Form.Group
                            className="form_group"
                            controlId="formBasicName"
                          >
                            <Form.Label>
                              {" "}
                              <Form.Check
                                inline
                                type="checkbox"
                                label="Test & Calibration:"
                                name="sampleType"
                                value="Test & Calibration:"
                              />
                            </Form.Label>
                          </Form.Group>
                        </div>

                        <div className="col-sm-6">
                          <Form.Group
                            className="form_group"
                            controlId="formBasicName"
                          >
                            <Form.Label>
                              {" "}
                              <Form.Check
                                inline
                                type="checkbox"
                                label="View available test parameters"
                                name="sampleType"
                                value="View available test parameters"
                              />
                            </Form.Label>
                          </Form.Group>
                        </div>
                        <div className="col-sm-6">
                          <Form.Group
                            className="form_group"
                            controlId="formBasicName"
                          >
                            <Form.Label>
                              {" "}
                              <Form.Check
                                inline
                                type="checkbox"
                                label="Assign tests to instruments or technicians"
                                name="sampleType"
                                value="Assign tests to instruments or technicians"
                              />
                            </Form.Label>
                          </Form.Group>
                        </div>
                        <div className="col-sm-6">
                          <Form.Group
                            className="form_group"
                            controlId="formBasicName"
                          >
                            <Form.Label>
                              {" "}
                              <Form.Check
                                inline
                                type="checkbox"
                                label="Update test progress & completion status"
                                name="sampleType"
                                value="Update test progress & completion status"
                              />
                            </Form.Label>
                          </Form.Group>
                        </div>
                        <div className="col-sm-6">
                          <Form.Group
                            className="form_group"
                            controlId="formBasicName"
                          >
                            <Form.Label>
                              {" "}
                              <Form.Check
                                inline
                                type="checkbox"
                                label="Approve/review test data before report generation"
                                name="sampleType"
                                value="Approve/review test data before report generation"
                              />
                            </Form.Label>
                          </Form.Group>
                        </div>
                        <div className="col-sm-6">
                          <Form.Group
                            className="form_group"
                            controlId="formBasicName"
                          >
                            <Form.Label>
                              {" "}
                              <Form.Check
                                inline
                                type="checkbox"
                                label="Enter test/calibration results"
                                name="sampleType"
                                value="Enter test/calibration results"
                              />
                            </Form.Label>
                          </Form.Group>
                        </div>
                      </div>
                    </div>

                    <div className="blue_div">
                      <div className="row">
                        <div className="col-sm-12">
                          <Form.Group
                            className="form_group"
                            controlId="formBasicName"
                          >
                            <Form.Label>
                              {" "}
                              <Form.Check
                                inline
                                type="checkbox"
                                label="Test & Calibration:"
                                name="sampleType"
                                value="Test & Calibration:"
                              />
                            </Form.Label>
                          </Form.Group>
                        </div>

                        <div className="col-sm-6">
                          <Form.Group
                            className="form_group"
                            controlId="formBasicName"
                          >
                            <Form.Label>
                              {" "}
                              <Form.Check
                                inline
                                type="checkbox"
                                label="View available test parameters"
                                name="sampleType"
                                value="View available test parameters"
                              />
                            </Form.Label>
                          </Form.Group>
                        </div>
                        <div className="col-sm-6">
                          <Form.Group
                            className="form_group"
                            controlId="formBasicName"
                          >
                            <Form.Label>
                              {" "}
                              <Form.Check
                                inline
                                type="checkbox"
                                label="Assign tests to instruments or technicians"
                                name="sampleType"
                                value="Assign tests to instruments or technicians"
                              />
                            </Form.Label>
                          </Form.Group>
                        </div>
                        <div className="col-sm-6">
                          <Form.Group
                            className="form_group"
                            controlId="formBasicName"
                          >
                            <Form.Label>
                              {" "}
                              <Form.Check
                                inline
                                type="checkbox"
                                label="Update test progress & completion status"
                                name="sampleType"
                                value="Update test progress & completion status"
                              />
                            </Form.Label>
                          </Form.Group>
                        </div>
                        <div className="col-sm-6">
                          <Form.Group
                            className="form_group"
                            controlId="formBasicName"
                          >
                            <Form.Label>
                              {" "}
                              <Form.Check
                                inline
                                type="checkbox"
                                label="Approve/review test data before report generation"
                                name="sampleType"
                                value="Approve/review test data before report generation"
                              />
                            </Form.Label>
                          </Form.Group>
                        </div>
                        <div className="col-sm-6">
                          <Form.Group
                            className="form_group"
                            controlId="formBasicName"
                          >
                            <Form.Label>
                              {" "}
                              <Form.Check
                                inline
                                type="checkbox"
                                label="Enter test/calibration results"
                                name="sampleType"
                                value="Enter test/calibration results"
                              />
                            </Form.Label>
                          </Form.Group>
                        </div>
                      </div>
                    </div>

                    <div className="yellow_div">
                      <div className="row">
                        <div className="col-sm-12">
                          <Form.Group
                            className="form_group"
                            controlId="formBasicName"
                          >
                            <Form.Label>
                              {" "}
                              <Form.Check
                                inline
                                type="checkbox"
                                label="Instrument Management:"
                                name="sampleType"
                                value="Test & Calibration:"
                              />
                            </Form.Label>
                          </Form.Group>
                        </div>

                        <div className="col-sm-6">
                          <Form.Group
                            className="form_group"
                            controlId="formBasicName"
                          >
                            <Form.Label>
                              {" "}
                              <Form.Check
                                inline
                                type="checkbox"
                                label="View instrument list & calibration schedule"
                                name="sampleType"
                                value="View available test parameters"
                              />
                            </Form.Label>
                          </Form.Group>
                        </div>
                        <div className="col-sm-6">
                          <Form.Group
                            className="form_group"
                            controlId="formBasicName"
                          >
                            <Form.Label>
                              {" "}
                              <Form.Check
                                inline
                                type="checkbox"
                                label="Mark instrument as active/inactive"
                                name="sampleType"
                                value="Assign tests to instruments or technicians"
                              />
                            </Form.Label>
                          </Form.Group>
                        </div>
                        <div className="col-sm-6">
                          <Form.Group
                            className="form_group"
                            controlId="formBasicName"
                          >
                            <Form.Label>
                              {" "}
                              <Form.Check
                                inline
                                type="checkbox"
                                label="Record instrument maintenance or service logs"
                                name="sampleType"
                                value="Update test progress & completion status"
                              />
                            </Form.Label>
                          </Form.Group>
                        </div>
                        <div className="col-sm-6">
                          <Form.Group
                            className="form_group"
                            controlId="formBasicName"
                          >
                            <Form.Label>
                              {" "}
                              <Form.Check
                                inline
                                type="checkbox"
                                label="Approve instrument calibration results"
                                name="sampleType"
                                value="Approve/review test data before report generation"
                              />
                            </Form.Label>
                          </Form.Group>
                        </div>
                      </div>
                    </div>

                             <div className="blue_div">
                      <div className="row">
                        <div className="col-sm-12">
                          <Form.Group
                            className="form_group"
                            controlId="formBasicName"
                          >
                            <Form.Label>
                              {" "}
                              <Form.Check
                                inline
                                type="checkbox"
                                label="Test & Calibration:"
                                name="sampleType"
                                value="Test & Calibration:"
                              />
                            </Form.Label>
                          </Form.Group>
                        </div>

                        <div className="col-sm-6">
                          <Form.Group
                            className="form_group"
                            controlId="formBasicName"
                          >
                            <Form.Label>
                              {" "}
                              <Form.Check
                                inline
                                type="checkbox"
                                label="View available test parameters"
                                name="sampleType"
                                value="View available test parameters"
                              />
                            </Form.Label>
                          </Form.Group>
                        </div>
                        <div className="col-sm-6">
                          <Form.Group
                            className="form_group"
                            controlId="formBasicName"
                          >
                            <Form.Label>
                              {" "}
                              <Form.Check
                                inline
                                type="checkbox"
                                label="Assign tests to instruments or technicians"
                                name="sampleType"
                                value="Assign tests to instruments or technicians"
                              />
                            </Form.Label>
                          </Form.Group>
                        </div>
                        <div className="col-sm-6">
                          <Form.Group
                            className="form_group"
                            controlId="formBasicName"
                          >
                            <Form.Label>
                              {" "}
                              <Form.Check
                                inline
                                type="checkbox"
                                label="Update test progress & completion status"
                                name="sampleType"
                                value="Update test progress & completion status"
                              />
                            </Form.Label>
                          </Form.Group>
                        </div>
                        <div className="col-sm-6">
                          <Form.Group
                            className="form_group"
                            controlId="formBasicName"
                          >
                            <Form.Label>
                              {" "}
                              <Form.Check
                                inline
                                type="checkbox"
                                label="Approve/review test data before report generation"
                                name="sampleType"
                                value="Approve/review test data before report generation"
                              />
                            </Form.Label>
                          </Form.Group>
                        </div>
                        <div className="col-sm-6">
                          <Form.Group
                            className="form_group"
                            controlId="formBasicName"
                          >
                            <Form.Label>
                              {" "}
                              <Form.Check
                                inline
                                type="checkbox"
                                label="Enter test/calibration results"
                                name="sampleType"
                                value="Enter test/calibration results"
                              />
                            </Form.Label>
                          </Form.Group>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>

               <div className="offcanvas_footer_holder">
                {!success ? (
                  <>
                    <div className="btns_holder">
                      <Gray_Btn btnText={"Cancel"} />
                      <Black_Submit_Btn
                        btnText={"Submit"}
                        onClick={() => {
                          setSuccess(true);
                        }}
                      />
                    </div>
                    <Refresh_btn/>
                  </>
                ) : (
                  <Success_Toster
                    successText={"Role Added Successfully!"}
                  />
                )}
              </div>
            </div>
          </Form>
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default Edit_Role;
